import { connect } from "react-redux";
import { AddVehicle as Component } from "./AddVehicle.component";
import { getAddVehicleByPlateVin, getPartnerCode } from "../../selector";
import { RootState } from "../../reducers";

const mapStateToProps = (state: RootState) => ({
  isAddVehicleByPlateVinFlow: getAddVehicleByPlateVin(state),
});

export const AddVehicle = connect(mapStateToProps, {
  getPartnerCode,
})(Component);
